/**
 * 表紙特集掲載商品選定（バイヤー）画面の一覧クラス
 *
 * @export CodeListInfo
 * @class CodeListInfo
 */
export class CodeListInfo {
    constructor(
      // コード
      public Code: string,
      // 名称
      public Name: string,
    ) {}
  }
  